// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__UrCKs","content":"Auth_content__ngxqz"};